export const createTimeOfDayData = (filteredInteractions) => {
    const timeOfDayData = {};
    for (let hour = 0; hour < 24; hour++) {
        timeOfDayData[hour] = { noInteraction: 0, withInteraction: 0 };
    }
    filteredInteractions.forEach((interaction) => {
        const startDate = new Date(interaction.InteractionStartDateUtc);
        const hour = startDate.getHours();
        if (isNaN(hour) || hour < 0 || hour > 23) {
            return;
        }
        const hasUserInput = interaction.ToFilterOriginator || interaction.ToFilterPriority || interaction.ToFilterReason;
        if (hasUserInput) {
            timeOfDayData[hour].withInteraction++;
        }
        else {
            timeOfDayData[hour].noInteraction++;
        }
    });
    return Object.entries(timeOfDayData).map(([hour, counts]) => ({
        hour: parseInt(hour),
        timeLabel: `${parseInt(hour).toString().padStart(2, "0")}:00`,
        ...counts,
        total: counts.noInteraction + counts.withInteraction,
    }));
};
export const createDayOfWeekData = (filteredInteractions) => {
    const dayOfWeekData = {};
    for (let day = 0; day < 7; day++) {
        dayOfWeekData[day] = { noInteraction: 0, withInteraction: 0 };
    }
    filteredInteractions.forEach((interaction) => {
        const startDate = new Date(interaction.InteractionStartDateUtc);
        const dayOfWeek = startDate.getDay();
        if (isNaN(dayOfWeek) || dayOfWeek < 0 || dayOfWeek > 6) {
            return;
        }
        const hasUserInput = interaction.ToFilterOriginator || interaction.ToFilterPriority || interaction.ToFilterReason;
        if (hasUserInput) {
            dayOfWeekData[dayOfWeek].withInteraction++;
        }
        else {
            dayOfWeekData[dayOfWeek].noInteraction++;
        }
    });
    const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    return Object.entries(dayOfWeekData).map(([day, counts]) => {
        const dayIndex = parseInt(day);
        return {
            day: dayIndex,
            dayLabel: dayNames[dayIndex] || "Unknown",
            ...counts,
            total: counts.noInteraction + counts.withInteraction,
        };
    });
};
//# sourceMappingURL=chartDataUtils.js.map